
import {ChannelStatus} from '../app/app.constants';

export class InfluencerSetting {
  first_name: string;
  email: string;
  phone: string;
  last_name: string;
  rewrite_email: string;
  avatar: string;
  old_password: string;
  new_password: string;
  repeat_new_password: string;
}

export class Channel {
  platforms: Array<number> = [];
}

export class PlatformSetting {
  platform: string;
  account: string;
  status: ChannelStatus;
  alert: boolean;
}

export class UpdateChannelRequest {
  id: number;
  handle: string;
  type: number;
  platform_id: number;
  blog_id: number;
  youtubeType: string;
}



// WEBPACK FOOTER //
// ./src/models/influencer-setting.ts